document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("MobileAgeVerifier");
  const yesBtn = document.getElementById("age-verify-yes");
  const noBtn = document.getElementById("age-verify-no");

  if (!modal) return;

  // Get config from HTML attributes
  const mode = modal.dataset.mode || 'enabled';
  const expiryDays = parseInt(modal.dataset.expiry) || 30;
  const storageKey = 'age-verified';
  const now = new Date().getTime();

  const getStoredValue = () => {
    try {
      return JSON.parse(localStorage.getItem(storageKey));
    } catch {
      return null;
    }
  };

  const setStoredValue = () => {
    localStorage.setItem(storageKey, JSON.stringify({
      confirmed: true,
      timestamp: now
    }));
  };

  const isExpired = (timestamp) => {
    const ms = expiryDays * 24 * 60 * 60 * 1000;
    return now - timestamp > ms;
  };

  const stored = getStoredValue();

  const shouldShowModal =
    mode === 'testing' ||
    !stored ||
    !stored.confirmed ||
    isExpired(stored.timestamp);

  if (shouldShowModal) {
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  } else {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  if (yesBtn) {
    yesBtn.addEventListener('click', () => {
      setStoredValue();
      modal.style.display = 'none';
      document.body.style.overflow = '';
    });
  }

  if (noBtn) {
    noBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const url = noBtn.getAttribute('href') || 'https://www.google.com';
      window.location.href = url;
    });
  }
});